import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedDate } from 'react-intl';

import { media } from '../../../styles/style-utils';
import { legacyType } from '../../../styles/typography';

import PriceTemplate from './PriceTemplate';
import { livestreamEventDecorator } from './LivestreamEvent';
import Hyperlink from '../../common/Hyperlink';
import arrowRightIcon from '../../../assets/images/arrow-right-circle-outline.svg';
import { getArtworkUrl } from '../utils/Contentful';
import { withSiteData } from 'react-static';

const Item = styled.div`
  position: relative;

  .preview {
    font-size: var(--fs-sm);
    ${legacyType('sm', 'body')};
    overflow: hidden;
    -webkit-line-clamp: 4; /* stylelint-disable-line property-no-vendor-prefix */
    -webkit-box-orient: vertical; /* stylelint-disable-line property-no-vendor-prefix */
    display: -webkit-box; /* stylelint-disable-line value-no-vendor-prefix */
    word-break: break-word;

    p {
      display: inline;
    }
  }

  h2 {
    font-size: var(--fs-l);
    margin-bottom: 0.5rem;
  }

  h3 {
    margin-bottom: 1.5rem;
    font-weight: 400;
  }

  img {
    width: 100%;
  }
`;

const Description = styled.div`
  margin-top: 2rem;
`;

const ViewCourseWrapper = styled.div`
  text-transform: uppercase;
  text-decoration: underline;
  font-size: var(--fs-focus);
  padding: 1rem 0;
  ${legacyType('focus', 'label', { uppercase: true })};
  display: inline-flex;
  justify-content: left;
  align-items: center;

  > :not(:last-child) {
    margin-right: 10px;
  }

  .icon {
    width: 24px;
    height: 24px;
  }

  ${media.mediumLarge`
    justify-content: center;
  `}
`;

const DateWrapper = styled.div`
  text-transform: uppercase;
  font-size: var(--fs-focus);
  font-weight: 500;
  ${legacyType('focus', 'label', { uppercase: true })};
`;

const PriceWrapper = styled.div`
  text-transform: uppercase;
  font-size: var(--fs-focus);
  font-weight: 900;
  ${legacyType('focus', 'label', { emphasis: true, uppercase: true })};
`;

const CourseItem = ({ content, appDomain }) => {
  const event = livestreamEventDecorator(content);
  const { title, slug, image } = content;

  return (
    <Item>
      {slug && (
        <Hyperlink
          to={`${appDomain}/live/event/${slug}`}
          className="dummy-btn"
          openInNewTab
          aria-label={title}
        />
      )}
      {image && <img src={getArtworkUrl(image)} alt="" />}
      <Description>
        {title && <h2>{title}</h2>}
        {event.startDate && (
          <DateWrapper>
            <FormattedDate
              weekday="short"
              month="long"
              day="numeric"
              year="numeric"
              value={event.startDate}
            />
          </DateWrapper>
        )}
        <PriceWrapper>
          <PriceTemplate event={event} />
        </PriceWrapper>
        {slug && (
          <ViewCourseWrapper>
            <FormattedMessage defaultMessage="View course" id="course.link-label" />
            <img src={arrowRightIcon} className="icon" alt="arrow right" />
          </ViewCourseWrapper>
        )}
      </Description>
    </Item>
  );
};

CourseItem.propTypes = {
  content: PropTypes.object,
  appDomain: PropTypes.string.isRequired,
};

export default withSiteData(CourseItem);



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/livestreamEvent/CourseItem.js